export default __webpack_public_path__ + "static/media/uturn-left.371375ba.svg";